import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Container, 
  IconButton, 
  Tooltip,
  Snackbar,
  Alert
} from '@mui/material';
import { AdminPanelSettings } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const [clickCount, setClickCount] = useState(0);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const navigate = useNavigate();

  const handleAdminClick = () => {
    const newCount = clickCount + 1;
    setClickCount(newCount);
    
    if (newCount === 5) {
      // Après 5 clics, rediriger vers la page admin
      navigate('/admin-login');
      setClickCount(0);
    } else if (newCount === 3) {
      // Après 3 clics, montrer un indice
      setShowSnackbar(true);
    }
  };

  return (
    <>
      <Box
        component="footer"
        sx={{
          bgcolor: 'grey.900',
          color: 'white',
          py: 3,
          mt: 'auto',
          position: 'relative'
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="body2">
              © 2024 LYS Artisans - Tous droits réservés
            </Typography>
            
            {/* Bouton admin caché - nécessite 5 clics */}
            <Tooltip title={clickCount >= 3 ? "Encore 2 clics pour l'accès admin" : ""}>
              <IconButton
                onClick={handleAdminClick}
                sx={{ 
                  opacity: 0.1,
                  '&:hover': { 
                    opacity: clickCount >= 3 ? 0.5 : 0.2 
                  },
                  transition: 'opacity 0.3s'
                }}
              >
                <AdminPanelSettings sx={{ color: 'grey.600' }} />
              </IconButton>
            </Tooltip>
          </Box>
        </Container>
      </Box>

      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => setShowSnackbar(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert 
          onClose={() => setShowSnackbar(false)} 
          severity="info"
          sx={{ width: '100%' }}
        >
          Mode admin détecté - 2 clics restants
        </Alert>
      </Snackbar>
    </>
  );
};

export default Footer;